import Vue from 'vue'
import Subscriber from './subscriber.js';
import store from '../store'
import { isMobile } from "./util.js";
// 连接websocket
function connect(cb) {
    var connecter = Vue.prototype.$ws;
    if (!connecter) {
	   const token = store.getters.token;
	   const userInfo = store.getters.userInfo;
	   if(!token||!userInfo.uid) return;
	   let wss_url = '';
	   const protocol = window.location.protocol=='https:'?'wss://':'ws://';
	   wss_url = protocol + window.location.host;
	   let type = 'room';
	   let from = 'PC';
	   const url = `${wss_url}/ws?type=${type}&uid=${userInfo.uid}&from=${from}&token=${token}`;
	   console.log(url)
     Vue.prototype.$ws = new Subscriber({url: url});
	   cb && cb();
    }else{
       cb && cb();
	}
}
function onMessage(data){
    Vue.prototype.$vm.$emit('onMessage', data);
}
function userMessage(data){
    Vue.prototype.$vm.$emit('onMessage', data);
    Vue.prototype.$vm.$emit('userMessage', data);
}
function revokeMessage(data){

}
function removeRoom(data){

}
// 监听某个群组的消息
function listenGroup (room_id, gid) {
  var connecter = Vue.prototype.$ws;
	if(!connecter) return;
    var key = 'group-' + room_id + '-' + gid;
    if (connecter.channels[key]) {
        return;
    }
    var group_channel = connecter.subscribe(key);
    group_channel.on('message', onMessage);
}
// 取消订阅某群组的消息
function unlistenGroup (room_id, gid) {
	var connecter = Vue.prototype.$ws;
	if(!connecter) return;
    connecter.unsubscribe('group-' + room_id + '-' + gid);
}
// 监听我的消息等
function listenUser(){
	  var uid = store.getters.userInfo.uid;
	  if(!uid) return;
    var do_listen = function(){
        var connecter = Vue.prototype.$ws;
        // 取消所有订阅
        if (connecter && typeof connecter.unsubscribeAll === 'function') {
                connecter.unsubscribeAll();
        }
        // 浏览器监听当前登录者的信息
        var user_channel = connecter.subscribe('room-' + uid);
        // 监听成功后
        user_channel.on('success', function () {

        });
        // 当前用户接收到消息
        user_channel.on('message', userMessage);
        // 当前用户接收到消息
        user_channel.on('count', (data)=>{
             Vue.prototype.$vm.$emit('cai_count', data);
        });
        user_channel.on('apply', (data)=>{
             Vue.prototype.$vm.$emit('apply', data);
        });
        user_channel.on('inroom', (data)=>{
             Vue.prototype.$vm.$emit('comeinroom', data);
        });
        // 当前用户接收到撤回消息
        user_channel.on('revoke', revokeMessage);
        // 移除一个房间
        user_channel.on('remove_room', removeRoom);
    }
    var connecter = Vue.prototype.$ws;
    if (!connecter) {
        connect(do_listen);
    } else {
        do_listen();
    }
}
// 清理
function cleanData(){
    var connecter = Vue.prototype.$ws;
    if (connecter) {
        connecter.unsubscribeAll();
        connecter.disconnect();
        Vue.prototype.$ws = null;
    }
}
export default {
  listenGroup: listenGroup,
	unlistenGroup: unlistenGroup,
	listenUser: listenUser,
	cleanData: cleanData
}



// WEBPACK FOOTER //
// ./src/api/chat.js